import { env } from '@/env';
import type { AppConfig } from '@/types/app-config';

import { lookerEnvFromWebappEnv } from './utils/looker-env-from-webapp-env';

export const appConfig: AppConfig = {
  bffUrl: env.VITE_WEBAPP_BFF_URL,
  defaultLookerEnv: lookerEnvFromWebappEnv(env.VITE_WEBAPP_ENV),

  auth0: {
    domain: env.VITE_AUTH0_DOMAIN,
    clientId: env.VITE_AUTH0_CLIENT_ID,
    audience: env.VITE_AUTH0_AUDIENCE,
    scope: 'openid email profile',
  },

  defaultAlertsFilters: {
    changedSinceDays: 365,
    groupIds: [],
    alertStatusList: ['Critical', 'Warning', 'Info'],
    alertTypeList: [],
  },

  linksFromDashboard: [
    {
      dashboardId: 'compatibility',
      redirectTo: '/data/compatibility',
      queryParams: ['top_id', 'unit_id'],
    },
    {
      dashboardId: 'assets',
      redirectTo: '/assets',
      queryParams: [
        'system_id',
        'array_id',
        'node_id',
        'container_id',
        'bank_id',
        'pack_id',
        'module_id',
      ],
    },
    {
      dashboardId: 'details',
      redirectTo: '/details',
      queryParams: [
        'system_id',
        'array_id',
        'node_id',
        'container_id',
        'bank_id',
        'pack_id',
        'module_id',
      ],
    },
  ],
};
